import React from 'react';
import { FieldValidator } from 'final-form';
import { RenderDropdown } from 'forms';
import { Validator } from 'forms/validators/types';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';
import { selectOrganizationOptions } from './selectors';

interface Props {
    name: string;
    validate?: FieldValidator<Validator>;
    label?: string;
    placeholder?: string;
    multiple?: boolean;
    disabled?: boolean;
    clearable?: boolean;
}

export default function OrganizationDropdown(props: Props): React.ReactElement {
    const {
        name,
        validate,
        label,
        placeholder,
        multiple,
        disabled = false,
        clearable = true
    } = props;

    const options = useSelector(selectOrganizationOptions);

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            validate={validate}
            label={label || 'Organization'}
            placeholder={placeholder || 'Select a organization'}
            fluid
            search
            selection
            clearable={clearable}
            selectOnBlur={false}
            multiple={multiple}
            options={options}
            disabled={disabled}
        />
    );
}
